<template>
  <div>
    <ed-absenteismo :intAbsenteismoId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdAbsenteismo from "@/components/absenteismo/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdAbsenteismo },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "absenteismo.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>